export const ErrorHint = ({ message }: { message: string }) => (
  <div className="relative">
    <div className="absolute top-full left-0">
      <span
        className="relative -top-1 text-xs text-red-500"
        data-testid="error-hint"
      >
        {message}
      </span>
    </div>
  </div>
)
